module.exports = __webpack_public_path__ + "media/components/t-shirt-comp/static/Playade-Berria-713c980cd9e31e3d07f1e56a5ad206a7.jpg";